var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    color: "#171D38",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.136 17.886h-.104C3.974 17.193 2.262 7.02 2.022 3.914a1.84 1.84 0 0 1 1.694-1.982h3.381a1.23 1.23 0 0 1 1.142.773L9.172 5a1.23 1.23 0 0 1-.27 1.325l-1.307 1.32a5.75 5.75 0 0 0 4.65 4.663l1.333-1.319a1.23 1.23 0 0 1 1.331-.252l2.313.927a1.23 1.23 0 0 1 .755 1.141v3.24a1.84 1.84 0 0 1-1.84 1.841M3.864 3.16a.614.614 0 0 0-.614.614v.049c.282 3.632 2.092 12.223 12.85 12.837a.614.614 0 0 0 .65-.577v-3.277l-2.313-.926-1.762 1.749-.294-.037c-5.339-.669-6.063-6.008-6.063-6.063l-.037-.294 1.743-1.762-.92-2.313z"
  })));
};
export default SvgPhone;